export default "__VITE_ASSET__DsJfzFeY__"